import './styles.css'

export function PrivacyPolicyPage() {
    return <div>Privacy Policy Page</div>
}
